/*
 * Copyright © 2025. TapClicks Inc. All rights reserved.
 *
 * Author: Rajesh Chittampally
 */

import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { AppModule, Module } from '@/modules/core/app/constants/app.constants';

export class InsightsHqRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return (
      userSettings.hasPermissionToRead(Module.INSIGHTSHQ) &&
      (userSettings.isModuleAvailable(AppModule.INSIGHTS_HQ) || userSettings.isRemoteLogin)
    );
  }
}
